var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgFacebook = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 4.67969H6.2C5 4.67969 4 5.67325 4 6.86552V18.4902C4 19.5831 5 20.5767 6.2 20.5767H12V14.9134H10.4C10.2 14.9134 10.1 14.7146 10 14.6153V12.8269C10 12.6282 10.2 12.4295 10.4 12.4295H11.9V10.6411C11.9 8.55457 13.2 7.46166 15 7.46166H16.5C16.7 7.46166 16.9 7.66037 16.9 7.85908V9.44878C16.9 9.64749 16.7 9.8462 16.5 9.8462H15.6C14.6 9.8462 14.4 10.343 14.4 11.0385V12.5288H16.6C16.8 12.5288 17 12.7275 16.9 12.9262L16.7 14.6153C16.7 14.814 16.5 14.9134 16.4 14.9134H14.4V20.5767H17.8C19 20.5767 20 19.5831 20 18.3908V6.86552C20 5.67325 19 4.67969 17.8 4.67969Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.2651,
    y1: 1.86195,
    x2: 10.4731,
    y2: 15.9309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.897,
    fill: "white",
    transform: "translate(4 4.67969)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Facebook.85d2b069.svg";
export { ForwardRef as ReactComponent };